export const cilHd = ["24 24","<path d='M17.063 6.375h-4.313v11.25h4.313c1.346-0.002 2.436-1.092 2.438-2.437v-6.375c-0.002-1.346-1.092-2.436-2.437-2.438h-0zM18 15.188c0 0.518-0.42 0.938-0.938 0.938v0h-2.813v-8.25h2.813c0.518 0 0.938 0.42 0.938 0.938v0z'></path><path d='M9.75 11.25h-3.75v-4.875h-1.5v11.25h1.5v-4.875h3.75v4.875h1.5v-11.25h-1.5v4.875z'></path><path d='M21.75 0.75h-19.5c-0.828 0-1.5 0.672-1.5 1.5v0 19.5c0 0.828 0.672 1.5 1.5 1.5v0h19.5c0.828 0 1.5-0.672 1.5-1.5v0-19.5c0-0.828-0.672-1.5-1.5-1.5v0zM21.75 21.75h-19.5v-19.5h19.5v19.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-hd.js
// module id = null
// module chunks = 